import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import PeriodModel from '@/models/entities/PeriodModel';
import type { SummarySpec } from '@/models/summaries';

/**
 * Compteurs d'une période (GET /period_summaries, lecture seule, lisible comme la période) : feuilles soumises
 * (« Demandes ») et leurs minutes, tenus par l'API. Ressource à part entière (comme les *Summary d'Igienair), demandée
 * par l'écran pour sa page (fetchSummaries, filtre period[]=…) ; period réduite à son identité.
 */
export default class PeriodSummaryModel extends AbstractApiModel {
  protected _path = '/period_summaries/{?id}';

  declare _tsFilters: { period?: id | id[] };

  @doc.model(() => PeriodModel) declare period: PeriodModel;
  @doc.number declare timeSheetCount: number;
  @doc.number declare totalMinutes: number;
}

/** Résumés des périodes : PeriodModel.periodSummary */
export const PERIOD_SUMMARIES: SummarySpec = { model: PeriodSummaryModel, parent: 'period', property: 'periodSummary' };
